import { NewBox as Box } from "@bca/ui-library";

import LoadingCard from "./LoadingCard";
import LoadingFilters from "./LoadingFilters";

const MobileLoadingTable: React.FunctionComponent = () => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        marginTop="xxl"
        data-testid="mobile-loading-table"
      >
        <LoadingFilters />
      </Box>
      <LoadingCard />
      <LoadingCard />
      <LoadingCard />
      <LoadingCard />
    </>
  );
};

export default MobileLoadingTable;
